import React from 'react'

import { BaseView, BaseText } from '@/components/base'
import { Avatar } from '@/components/Avatar'
import { getBlockchainSymbol } from '@/utils/blockchain'
import { NetworkSelectorProps } from './types'

export const NetworkSelector: React.FC<NetworkSelectorProps> = ({
  blockchain,
  onPress,
  isLoading = false,
  isSelected = false,
  height,
}) => {
  if (isLoading) {
    return (
      <BaseView
        className="bg-gray-600 animate-pulse rounded-xl"
        style={{ height: height || 76, width: '100%' }}
      />
    )
  }

  return (
    <BaseView
      row
      align="center"
      gap={12}
      px={16}
      py={12}
      style={{
        height: height,
        backgroundColor: '#242427',
        borderRadius: 34,
        cursor: onPress ? 'pointer' : 'default',
      }}
      onClick={onPress}
    >
      {/* Network Icon */}
      <Avatar
        imageUrl={blockchain.img_url}
        initials={getBlockchainSymbol(blockchain.code)}
        size={48}
      />

      {/* Network Info */}
      <BaseView flex={1}>
        <BaseText fontSize={16} fontFamily="semibold" color="label.default">
          {blockchain.name}
        </BaseText>
        {/* {blockchain.arrival_time && (
          <BaseText fontSize={14} color="label.description">
            {t('translation:withdraw.processingTime', 'Processing time')}: ~{blockchain.arrival_time}{' '}
            {t('translation:minutes', 'minutes')}
          </BaseText>
        )} */}
      </BaseView>

      {/* Arrow - only show if clickable */}
      {/* {onPress && (
        <BaseView style={{ flexShrink: 0 }}>
          <ChevronRight size={24} color="rgba(255, 255, 255, 0.6)" />
        </BaseView>
      )} */}
    </BaseView>
  )
}
